"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processorFactory = void 0;
var tslib_1 = require("tslib");
var generateTPAParams_1 = require("tpa-style-webpack-plugin/dist/runtime/generateTPAParams");
var processor_1 = require("tpa-style-webpack-plugin/dist/runtime/processor");
var cssFunctions_1 = require("tpa-style-webpack-plugin/dist/runtime/cssFunctions");
var plugins_1 = require("tpa-style-webpack-plugin/dist/runtime/plugins");
function withCache(calc) {
    var cache = {};
    return function (arg) {
        var cachedRes = cache[arg];
        if (cachedRes !== undefined) {
            return cachedRes;
        }
        var res = calc(arg);
        cache[arg] = res;
        return res;
    };
}
var additionalCssFunctions = {
    divide: function (a, b) {
        return a / b;
    },
    arrowPaddingTop: function (itemsPerPage, tpaParams) {
        var thumbnailSpacing = tpaParams.numbers.thumbnailSpacing;
        return "calc(".concat(56.25 / itemsPerPage, "% - ").concat((thumbnailSpacing * 9) / 16, "px)");
    },
};
function processorFactory(cssVars) {
    var plugins = new plugins_1.Plugins();
    var allCssFunctions = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, cssFunctions_1.cssFunctions), additionalCssFunctions);
    Object.keys(allCssFunctions).forEach(function (funcName) {
        return plugins.addCssFunction(funcName, allCssFunctions[funcName]);
    });
    var processor = (0, processor_1.getProcessor)({
        cssVars: cssVars,
        plugins: plugins,
    });
    return function (_a) {
        var siteColors = _a.siteColors, siteTextPresets = _a.siteTextPresets, styleParams = _a.styleParams;
        var options = { isRTL: false, strictMode: true };
        var tpaParams = (0, generateTPAParams_1.generateTPAParams)(siteColors, siteTextPresets, styleParams, options);
        return withCache(function (part) { return processor.process({ part: part, tpaParams: tpaParams }); });
    };
}
exports.processorFactory = processorFactory;
//# sourceMappingURL=processor.js.map